import axios from 'axios';
import { NETWORK } from '../../../../framework/App/AppConstants';
import { APP_PEND_DOCUMENT_UPLOAD_API} from '../../../config/apiEndpoints';
import { safeStringifyAxios } from '../../../../shared-utilities/safeStringify';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import { sessionTimeoutHandler } from '../utils/sessionTimeoutHandler';

export const UploadDocument = (formData) => (dispatch, getState) => {
    const logPrefix = 'appPendUploadDocument:';
    const { serverData: { _csrf = '', flow = '' } = {} } = getState();
    return axios
        .request({
            url: APP_PEND_DOCUMENT_UPLOAD_API,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data: formData
        })
        .then((response) => {
            const { data = {} } = response;
            capeLog && capeLog(`${logPrefix} response: ${safeStringifyAxios(response)}`);
            dispatch(trackTransition('apply_pp_credit_uploadDocument', 'uploaded_pp_credit_uploadDocument', { document_type: formData.get('type')}));
            return data;
        })
        .catch(error => {
            capeLog && capeLog('response:error, UploadCardAction,' + (error && error.message));
            sessionTimeoutHandler(error, dispatch, flow);
        });
};
